<template>
  <div>
    <page-view :page="page" />
  </div>
</template>
<script>
  import PageView from '../components/PageView.vue'
  import Mixins from '../helpers/Mixins'

  export default {
    name: 'PagePage',
    components: {
      PageView
    },
    mixins: [
      Mixins
    ],
    data () {
      return {
        page: {}
      }
    },
    watch: {
      '$route.params.slug': function () {
        this.getPageData()
      }
    },
    mounted () {
      this.getPageData()
    },
    methods: {
      /**
       * Get, set and cache the page DTO
       * @method getPageData
       * @return void
       * **/
      getPageData () {
        const store = this.$store
        const getters = store.getters
        const slug = this.$route.path.split('/')[2]
        const page = getters.page(slug)
        if (page) {
          this.page = page
          this.setTitle(this.page.title_plain)
        } else {
          const ajax = store.state.events.ajax
          const base = getters.apiProxyUrl
          const resource = 'get_page'
          const url = `${base}/?resource=${resource}&page_slug=${slug}`
          this.$root.$emit(ajax, true)
          this.$http(url).then(response => {
            response = response.data.page
            if (!response) {
              this.to404()
              return
            }
            store.commit('setPage', response)
            this.page = getters.page(slug)
            this.$root.$emit(ajax, false)
          })
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/PagePage.vue